import { render, staticRenderFns } from "./nav-info.vue?vue&type=template&id=7f72ccae&scoped=true"
import script from "./nav-info.vue?vue&type=script&lang=ts"
export * from "./nav-info.vue?vue&type=script&lang=ts"
import style0 from "./nav-info.vue?vue&type=style&index=0&id=7f72ccae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f72ccae",
  null
  
)

export default component.exports